import { Link } from "react-router-dom";
import { useI18n } from "../i18n/index.js";
import styles from "./Header.module.css";

export function Header() {
  const { lang, setLang, t } = useI18n();

  return (
    <header className={styles.header}>
      <Link to="/" className={styles.brand}>
        {t("app.suiteName")}
      </Link>
      <div className={styles.langSwitch} role="group" aria-label={t("nav.langSwitch.label")}>
        <button
          type="button"
          className={styles.langButton}
          aria-pressed={lang === "de"}
          onClick={() => setLang("de")}
        >
          {t("nav.langSwitch.de")}
        </button>
        <button
          type="button"
          className={styles.langButton}
          aria-pressed={lang === "en"}
          onClick={() => setLang("en")}
        >
          {t("nav.langSwitch.en")}
        </button>
      </div>
    </header>
  );
}
